<label class="selected-label cursor-pointer mb-3" *ngFor="let checkboxCard of checkboxCards">
  <input
    [type]="singleSelect ? 'radio' : 'checkbox'"
    name="selected-item"
    [value]="checkboxCard.value"
    [checked]="checkboxCard.checked"
    [disabled]="checkboxCard.disabled"
    (change)="checkBoxChange($event)"
  />
  <span class="icon"></span>
  <div class="selected-content">
    <div class="indent">
      <div class="d-flex align-items-center">
        <div class="bold" [innerHtml]="checkboxCard.label"></div>
      </div>
      <!-- New body text section -->
      <div class="form-text text-muted mt-2" *ngIf="checkboxCard.body" [innerHtml]="checkboxCard.body"></div>

      <ul class="list-group list-group-flush">
        <li class="list-group-item px-0 font-weight-light" *ngFor="let listItem of checkboxCard.listItems">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <div *ngIf="listItem.leftTextHeader" class="small text-muted mb-1" [innerHtml]="listItem.leftTextHeader"></div>
              <div [innerHtml]="listItem.leftText"></div>
            </div>
            <div class="ml-auto text-right">
              <div *ngIf="listItem.rightTextHeader" class="small text-muted mb-1" [innerHtml]="listItem.rightTextHeader"></div>
              <div [innerHtml]="listItem.rightText"></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="bg-grey" [class.mt-3]="checkboxCard.listItems?.length === 0" *ngIf="checkboxCard.banner">
      <div class="indent">
        <div class="d-flex py-2">
          <div [innerHtml]="checkboxCard.banner.leftText"></div>
          <div class="ml-auto bold" [innerHtml]="checkboxCard.banner.rightText"></div>
        </div>
      </div>
    </div>
  </div>
</label>
